import React from "react";
import { connect } from "react-redux";
import { showLoading, hideLoading } from 'react-redux-loading-bar';
import {FormattedMessage} from "react-intl";
import {useLocation} from "react-router-dom";

import CircularProgress from '@mui/material/CircularProgress';

import LoadingBar from '../../lib/react-redux-loading-bar';
import store from '../../store';
import {toggleLoader} from "../../actions/actionFunctions";
import COLOR_THEMES, {COLORS} from "../../colorThemes";
import {IS_LIXIL_UI, IS_OFFLINE_MODE, IS_QKB_UI} from "../../config";
import {ROUTES} from "../../routes";
import featuresWorker from "../../webWorkers/featuresWorker";

const LoaderView = (props) => {

  const {iframe, loaderTitle, loaderText, loaderOpened, lookOpened, loaderFullScreen, activeTheme,
    visualizersLoaded, lookOverlayOpened} = props;

  let location = useLocation();
  const shouldHideLoader = !loaderOpened
    || (IS_QKB_UI && location && (location.pathname === ROUTES.home || location.pathname === ROUTES.quoteDesign));
  const loaderVisibilityStyle = shouldHideLoader ? {display: 'none'} : null;

  if (IS_LIXIL_UI) {
    const color = visualizersLoaded.length ? COLORS.white : COLOR_THEMES[activeTheme].active
    return (
      <div style={{'color': color, ...(loaderVisibilityStyle || {})}} className={"loader loader--fixed" + (visualizersLoaded.length ? "" : " loader--first loader--simple")
        + (lookOpened && !loaderFullScreen && !lookOverlayOpened ? " loader--with-menu" : "")}>
        <LoadingBar className="loader-counter"/>
        <CircularProgress style={{'color': color}}/>
      </div>
    )
  }

  // const {fabricatorData} = this.props;
  return (
    <div className={iframe ? "full-screen-wrapper-iframe" : "full-screen-wrapper"} style={loaderVisibilityStyle}>
      <div className="message-loading-container-centered">
        <div className="message-loading-left-panel message-loading-panel-settings">
          <div className="message-loading-left-panel-spinner"/>
          <LoadingBar className="message-loading-left-panel-counter"/>
        </div>
        <div className="message-loading-right-panel message-loading-panel-settings">
          <h1><FormattedMessage id={loaderTitle}/></h1>
          <p><FormattedMessage id={loaderText}/></p>
          {/*{fabricatorData.received ? <h1><FormattedMessage id={loaderTitle}/></h1> : null}*/}
          {/*{fabricatorData.received ? <p><FormattedMessage id={loaderText}/></p> : null}*/}
        </div>
      </div>
    </div>
  );

}

const mapStateToProps = (store) => {
  const {activeTheme, visualizersLoaded} = store.serverState;
  const {loaderOpened, loaderTitle, loaderText, loaderFullScreen} = store.loaderState;
  const {lookOpened, lookOverlayOpened} = store.lookState;
  return {
    activeTheme,
    visualizersLoaded,
    loaderOpened,
    loaderTitle,
    loaderText,
    loaderFullScreen,
    lookOpened,
    lookOverlayOpened,
  };
};

export default connect(mapStateToProps, {})(LoaderView);

export function loaderEnable(loaderText = "loader.defaultText", loaderTitle = "loader.defaultTitle") {
  //null value is passed, and not defaulted with the above, so the below 2 lines handle if null or other falsey value is passed
  loaderText = loaderText || "loader.defaultText";
  loaderTitle = loaderTitle || "loader.defaultTitle";
  store.dispatch(showLoading());
  store.dispatch(toggleLoader(true, loaderText, loaderTitle));
}

export function loaderDisable() {
  if (IS_OFFLINE_MODE && featuresWorker && !featuresWorker.allOfflinefeaturesReceived) {
    return // prevent canvas to remove loader, wait until features are received
  }
  store.dispatch(hideLoading());
  store.dispatch(toggleLoader(false));
}
